const STRAIGHT_TOP = (diameter) => ["l", diameter, 0];
const BROKEN_TOP = (diameter) => [
  "c", diameter/10, -diameter/6, diameter/2 - diameter/10, -diameter/6, diameter/2, 0,
  "s", diameter/2 - diameter/10, diameter/6, diameter/2, 0
];
const POINTED_TIP = (diameter, sideLength) => [
  "l", -diameter, diameter,
  "l", 0, -(sideLength + diameter)
];
const FLAT_TIP = (diameter, sideLength) => [
  "l", -diameter, 0,
  "l", 0, -sideLength
]

export default function ShaftGraphic({
  diameter=6,
  positionFromTop=0,
  shaftLength:shaftDepth=5,
  lead_extension='Extension',
  type=lead_extension,
  aboveGrade=0,
  factorY
}) {
  if (type === 'Extension') return null;

  const shaftTop = Math.max(-aboveGrade || 0, -1.5);
  const shaftLength = shaftDepth - shaftTop;
  const sideLength = (positionFromTop + shaftLength)*factorY;
  const topPath = shaftTop < -1 ? BROKEN_TOP : STRAIGHT_TOP;
  const bottomPath = type === 'Lead' ? POINTED_TIP : FLAT_TIP;


  return (
    <path
      className="shaft-segment"
      d={[
        "M", -diameter/2, shaftTop*factorY,
        ...topPath(diameter),
        "l", 0, sideLength,
        ...bottomPath(diameter, sideLength)
      ].join(" ")} />
  );
}
